import _extends from "@babel/runtime/helpers/extends";
import React, { memo, useRef, useCallback, useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import ImageGallery from 'react-image-gallery';
import { getOverrides, useClasses } from '../../../utils/overrides';
import { createUseStyles } from '../../../utils/styles';
import Icon from '../../general/Icon';
import styles from './styles';
const useStyles = createUseStyles(styles, 'Carousel');
var _ref2 = /*#__PURE__*/React.createElement(Icon, {
  name: "chevronLeft",
  size: "large",
  color: "white"
});
var _ref3 = /*#__PURE__*/React.createElement(Icon, {
  name: "chevronRight",
  size: "large",
  color: "white"
});
const Carousel = _ref => {
  let {
    classes: classesProp,
    overrides: overridesProp,
    className: classNameProp,
    images,
    placeholder,
    minVersion
  } = _ref;
  const classes = useClasses(useStyles, classesProp);
  const override = getOverrides(overridesProp, Carousel.overrides);
  const rootClass = classnames(classNameProp, classes.root, {
    [classes.minimalist]: minVersion
  });
  const galleryRef = useRef();
  const [isFull, setFull] = useState(false);
  const onScreenChange = useCallback(isFullscreen => {
    setFull(isFullscreen);
  }, []);
  const onClick = useCallback(() => {
    var _galleryRef$current;
    if (isFull || !minVersion) return;
    (_galleryRef$current = galleryRef.current) === null || _galleryRef$current === void 0 || _galleryRef$current.toggleFullScreen();
  }, [isFull, minVersion]);
  const leftNav = useCallback((onClick, disabled) => {
    return /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "image-gallery-icon image-gallery-left-nav",
      disabled: disabled,
      onClick: onClick,
      "aria-label": "Previous Slide"
    }, _ref2);
  }, []);
  const rightNav = useCallback((onClick, disabled) => {
    return /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "image-gallery-icon image-gallery-right-nav",
      disabled: disabled,
      onClick: onClick,
      "aria-label": "Next Slide"
    }, _ref3);
  }, []);
  const fullscreenButton = useCallback((onClick, isFullscreen) => {
    if (minVersion && !isFullscreen) return null;
    return /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "image-gallery-icon image-gallery-fullscreen-button",
      onClick: onClick,
      "aria-label": "Open Fullscreen"
    }, /*#__PURE__*/React.createElement(Icon, {
      name: isFullscreen ? 'close' : 'fullscreen',
      size: "large",
      color: "white"
    }));
  }, [minVersion]);
  if (!images) return null;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: rootClass
  }, override.root, {
    onClick: onClick
  }), /*#__PURE__*/React.createElement(ImageGallery, _extends({
    ref: galleryRef,
    items: images,
    onErrorImageURL: placeholder,
    showThumbnails: isFull,
    useBrowserFullscreen: false,
    showPlayButton: false,
    showBullets: false,
    showNav: !minVersion || isFull,
    showFullscreenButton: true,
    renderLeftNav: leftNav,
    renderRightNav: rightNav,
    renderFullscreenButton: fullscreenButton,
    onScreenChange: onScreenChange
  }, override.ImageGallery)));
};
Carousel.overrides = ['root', 'ImageGallery'];
Carousel.defaultProps = {
  overrides: {},
  images: [],
  minVersion: false
};
process.env.NODE_ENV !== "production" ? Carousel.propTypes = {
  className: PropTypes.string,
  overrides: PropTypes.object,
  // Image URL placeholder
  placeholder: PropTypes.string,
  images: PropTypes.arrayOf(PropTypes.shape({
    original: PropTypes.string
  }))
} : void 0;
export default /*#__PURE__*/memo(Carousel);